export const setCustomer = 'setCustomer'
export const setCustomers = 'setCustomers'
export const setCustomerActive = 'setCustomerActive'
export const setFilterCustomer = 'setFilterCustomer'
export const clearFilterCustomer = 'clearFilterCustomer'
export const clearFilterCustomers = 'clearFilterCustomers'




// WEBPACK FOOTER //
// ./src/app/pages/customers/vuex/mutations-types.js